<template>
  <button class="c_button_border" v-on:click="actionClick" v-html="msg"></button>
</template>
<script>
export default {
  name: 'CButtonBorder',
  props: {
    msg: String,
    actionClick: Function
  }
}
</script>

<style scoped>
.c_button_border {
  width: 500px;
  height: 90px;
  border: solid 1px #000000;
  background-color: #ffffff;
  font-size: 40px;
  font-weight: 200;
  font-style: normal;
  font-stretch: normal;
  line-height: 1;
  letter-spacing: 0.8px;
  text-align: center;
  color: #000000;
  cursor: pointer;
}
.c_button_border .center {
  margin: auto;
  display: block;
}
.c_button_border:focus {
  outline: none;
}
</style>
